import { render } from "./MdsBuscarEntidad.vue?vue&type=template&id=0711d488&scoped=true"
import script from "./MdsBuscarEntidad.vue?vue&type=script&lang=js"
export * from "./MdsBuscarEntidad.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0711d488"]])

export default __exports__